<template>
  <div style="background-color: #fff">
    <div class="fincal-content">
      <p class="fincal-head" style="margin-top: 7%">
        <a class="fincalrouter" href="">Home</a> » Terms
      </p>
      <h2 class="oplicy-h1">
        <img
          src="../assets/2023/12/disclaimer-300x300.gif"
          style="width: 80px"
          alt=""
        />
        Online Disclaimer
      </h2>
      <h3>Online Disclaimer Regarding Information</h3>
      <div class="fincal-wenzi fincal-head">
        The information from or through this site is provided “as-is,” “as
        available,” and all warranties, expressed or implied, are disclaimed
        (including but not limited to the disclaimer of any implied warranties
        of merchantability and fitness for a particular purpose). The
        information may contain errors, problems or other limitations. Our sole
        and entire maximum liability for any inaccurate information, for any
        reason, and user’s sole and exclusive remedy for any cause whatsoever,
        shall be limited to the amount paid by the customer for the information
        received (if any). We are not liable for any indirect, special,
        incidental, or consequential damages (including damages for loss of
        business, loss of profits, litigation, or the like). Whether based on
        breach of contract, breach of warranty, tort (including negligence),
        product liability or otherwise, even if advised of the possibility of
        such damage. The limitations of damages set forth above are fundamental
        elements of the basis of this agreement between you and company search
        incorporated. We would not provide this site and information without
        such limitations. No representations, warranties or guarantees
        whatsoever are made as to the accuracy, adequacy, reliability,
        timeliness, completeness, suitability or applicability of the
        information to a particular situation.
      </div>
        <div class="fincal-wenzi fincal-head">
    All responsibility and liability for any damages caused by viruses contained within the electronic files of this site are disclaimed.
      </div>
        <div class="fincal-wenzi fincal-head">
  All terms and conditions with respect to this site are governed by a Terms of the Service Agreement.
      </div>

<h3>Online Disclaimer Regarding Hyperlinks</h3>
      <div class="fincal-wenzi fincal-head">
       This site contains links to other Internet sites. These links are provided solely as a convenience to you and are not endorsements of any products or services in such sites, and no information in such site has been endorsed or approved by us. These third-party sites may also contain opinions and viewpoints of third parties that do not necessarily coincide with our opinions and viewpoints. Those sites may also have privacy policies different than our policy.
      </div>
    <h2 class="oplicy-h1">
        <img
          src="../assets/2023/12/copyright-policy-300x300.gif"
          style="width: 80px"
          alt=""
        />
        Copyright Policy
      </h2>
   

      <div class="fincal-wenzi ">
   The content, organization, graphics, design, compilation, magnetic translation, digital conversion and other matters related to the Site are protected under applicable copyrights, trademarks and other proprietary (including but not limited to intellectual property) rights. The copying, redistribution, use or publication by you of any such matters or any part of the Site, is strictly prohibited. You do not acquire ownership rights to any content, document or other materials viewed through the Site. The posting of information or materials on the Site does not constitute a waiver of any right in such information and materials. Some of the content on the site is the copyrighted work of third parties.

      </div>
      <div class="fincal-wenzi ">
Unless otherwise stated, the logo, copyright, database and similar rights in all published material on the CSIbizInfo website are owned by ‘Company Search Incorporated’. You are only permitted to print or download from this material for only your internal corporate or personal use. None of this material may be used for any commercial or public use.
      </div>

      <div class="fincal-wenzi fincal-head">
  No part of the CSIbizInfo website or any material appearing on the site may be reproduced, stored in or transmitted to any other website without written permission of Company Search Incorporated. You may send your requests to republish any material to request@CSIbizInfo.com
      </div>
    <h2 class="oplicy-h1">
        <img
          src="../assets/2023/12/contract-300x300.gif"
          style="width: 80px"
          alt=""
        />
       Terms of Use Agreement
      </h2>
   
      <div class="fincal-wenzi fincal-head">
      By using our site, you are agreeing to comply with and be bound by the following terms of use. Please review the following terms carefully. If you do not agree to these terms, you should not use this site. The term ‘CSIbizInfo’ or “us” or “we” or “our” refers to ‘Company Search Incorporated’, the owner of the Website. The term “you” refers to the user or viewer of our website.
      </div>
  
      <h3>Acceptance of Agreement</h3>
      <div class="fincal-wenzi fincal-head">
  You agree to the terms and conditions outlined in this Terms of Use Agreement (“Agreement”) with respect to our website (the “Site”). This Agreement constitutes the entire and only agreement between us and you, and supersedes all prior or contemporaneous agreements, representations, warranties and understandings with respect to the Site, the content, products or services provided by or through the Site, and the subject matter of this Agreement. This Agreement may be amended at any time, at our absolute discretion, from time to time without specific notice to you. The latest Agreement will be posted on the Site, and you should review this Agreement prior to using the Site.
      </div>
        <h3>Service Markst</h3>
      <div class="fincal-wenzi fincal-head">
        ‘CSIbizInfo.com’ and others are our service marks, registered service marks or trademarks. Other product and company names mentioned on the Site may be trademarks of their respective owners.
      </div>
 
         <h3>Limited License; Permitted Uses</h3>
      <div class="fincal-wenzi">
  You are granted a non-exclusive, non-transferable, revocable license (a) to access and use the Site strictly in accordance with this Agreement; (b) to use the Site solely for internal, personal, non-commercial purposes; and (c) to print out discrete information (or electronic version) from the Site solely for internal, personal, non-commercial purposes and provided that you maintain all copyright and other policies contained therein. No print out or electronic version of any part of the Site or its contents may be used by you in any litigation or arbitration matter whatsoever under any circumstances.
      </div>
            <h3>Restrictions and Prohibitions on Use</h3>
      <div class="fincal-wenzi">
        Your license for access and use of the Site and any information, materials or documents (collectively defined as “Content and Materials”) therein are subject to the following restrictions and prohibitions on use: You may not (a) copy, print (except for the express limited purpose permitted above), republish, display, distribute, transmit, sell, rent, lease, loan or otherwise make available in any form or by any means all or any portion of the Site or any Content and Materials retrieved there from; (b) use the Site or any materials obtained from the Site to develop, of as a component of, any information, storage and retrieval system, database, information base, or similar resource (in any media now existing or hereafter developed), that is offered for commercial distribution of any kind, including through sale, license, lease, rental, subscription, or any other commercial distribution mechanism; (c) create compilations or derivative works of any Content and Materials from the Site; (d) use any Content and Materials from the Site in any manner that may infringe any copyright, intellectual property right, proprietary right, or property right of us or any third parties; (e) remove, change or obscure any copyright notice or other proprietary notice or terms of use contained in the Site; (f) make any portion of the Site available through any timesharing system, service bureau, the Internet or any other technology now existing or developed in the future; (g) remove, decompile, disassemble or reverse engineer any Site software or use any network monitoring or discovery software to determine the Site architecture; (h) use any automatic or manual process to harvest information from the Site; (i) use the Site for the purpose of gathering information for or transmitting (1) unsolicited commercial email; (2) email that makes use of headers, invalid or nonexistent domain names, or other means of deceptive addressing; and (3) unsolicited telephone calls or facsimile transmissions; (j) use the Site in a manner that violates any state or federal law regulating email, facsimile transmissions or telephone solicitations; and (k) export or re-export the Site or any portion thereof, or any software available on or through the Site.
      </div>
             <h3>Forms, Agreements & Documents</h3>
      <div class="fincal-wenzi">
        We may make available through the Site or through other Websites sample and actual forms, checklists, business documents and legal documents (collectively, “Documents”). All Documents are provided on a non-exclusive license basis only for your personal one-time use for non-commercial purposes, without any right to re-license, sublicense, distribute, assign or transfer such license. Documents are provided for a charge and without any representations or warranties, express or implied, as to their suitability, legal effect, completeness, currentness, accuracy, and/or appropriateness. The Documents are provided “as is”, “as available”, and with “all faults”, and we and any provider of the Documents disclaim any warranties, including but not limited to the warranties of merchantability and fitness for a particular purpose. The Documents may be inappropriate for your particular circumstances. Furthermore, state or provincial laws may require different or additional provisions to ensure the desired result. You should consult with legal counsel to determine the appropriate legal or business documents necessary for your particular transactions, as the Documents are only samples and may not be applicable to a particular situation. Some Documents are public domain forms or available from public records.
      </div>
                <h3>No Legal Advice or Attorney-Client Relationship</h3>
      <div class="fincal-wenzi">
        Information contained on or made available through the Site is not intended to and does not constitute legal advice, recommendations, mediation or counseling under any circumstance and no attorney-client relationship is formed. We do not warrant or guarantee the accurateness, completeness, adequacy or currentness of the information contained in or linked to the Site. Your use of information on the Site or materials linked to the Site is entirely at your own risk. We are not a law firm and the Site is not a lawyer referral service.
      </div>
  
    </div>
  </div>
</template>
<script>
export default {
  name: "Products",
  data() {
    return {};
  },
  watch: {
    //   '$route.hash': function() {
    //     // 在这里可以处理hash变化后的逻辑
    //   this.scrollToAnchor()
    //   }
  },
  methods: {
    //  scrollToAnc
    gotoarticle(route) {
      console.log(route);
      this.$router.push({ name: route });
      // window.location.hash = "#about#top";
    },
    //   const el = document.querySelector(this.$route.hash);
    //   el.scrollIntoView({ behavior: "smooth" });
    // },
  },
  mounted() {
    window.scrollTo(0, 0);
    // this.scrollToAnchor()
  },
};
</script>

<style scoped>
ol,
ul {
  margin-left: 30px;
}
* {
  box-sizing: border-box;
  margin: 0;
  padding: 0;
}
.nectar-video-inner {
  width: 100%;
  position: relative;
  height: 610px;
}
.row-bg-layer {
  position: absolute;
  width: 100%;
  height: 610px;
  z-index: 9;
}
.row-bg-layertwo {
  position: absolute;
  width: 100%;
  height: 390px;
  z-index: 9;
}
.video-content {
  /* z-index: 10; */
  width: 100%;
  display: flex;
  justify-content: center;
  /* position: relative; */
}
.postion {
  position: absolute;
  top: 26%;
  right: 19%;
  width: 25%;
  z-index: 11;
}
.video-content-title {
  font-size: 81px;
  color: #fff;
  margin-bottom: 0px;
  width: 83%;
  margin: auto;
  text-align: center;
}
.video-content-left {
  position: absolute;
  z-index: 11;
  top: 36%;
  text-align: center;
}
.start_font {
  font-family: "AlegreyaSans-Medium";
  font-size: 61px;
  width: auto;
  color: #1290c9;
  text-align: left;
  font-style: normal;
  position: relative;
  display: inline-block;
  z-index: 10;
}
.focus {
  position: relative;
}
h2 {
  font-family: Alegreya Sans;
  font-size: 46px;
  line-height: 56px;
  font-weight: 500;
  margin: 7px 0px;
}

head {
}
h3 {
  font-family: Alegreya Sans;
  font-size: 28px;
  line-height: 38px;
  font-weight: 500;
  /* color: #3d7cbf; */
  text-align: left;
  margin-bottom: 8px;
  margin-top: 10px;
}
.nectar-video-bg {
  height: 100%;
  position: relative;
  top: -25%;
}
.Financial-text {
  padding: 0 20px;
  border-left: 1px solid #ccc;
  color: #fff;
}
.fincalrouter {
  color: #1290c9;
}
.fincal-content {
  margin: auto;
  width: 88%;
  padding: 80px 0px;
  font-size: 18px;
}
.fincal-head {
  padding-bottom: 27px;
}
.fincal-wenzi {
   font-family: "Roboto" !important;
  font-size: 18px;
  line-height: 32px;
  font-weight: 400;
}
.wenzhang {
  color: #fff;
  padding: 6px;
  font-size: 14px;
  border: 1px solid #ccc;
  width: 200px;
  margin: auto;
  margin-top: -50px;
  border-radius: 5px;
  margin-bottom: 20px;
}
.wenzhangtwo {
  color: #fff;
  padding: 6px;
  font-size: 18px;
  margin: auto;
}
.nectar-video-innertwo {
  height: 390px;
  background-image: url("../assets/2024/01/artificial-intelligence-leadership.webp");
  background-position-y: 631px;
  transition: transform 0.42s ease;
  background-size: 100%;
}
.nextewnzheng {
  overflow: hidden;
}
.nextewnzheng {
  transition: transform 0.42s ease;
}

.nextewnzheng:hover .nectar-video-innertwo {
  cursor: pointer;
  transform: scale(1.1);
  transition: transform 0.42s ease;
}
.nextewnzheng :hover .row-bg-layertwo {
  opacity: 0.1 !important;
}
@media screen and (max-width: 500px) {
  .video-content-title {
    font-size: 51px;
  }
}
.oplicy-h1 {
  display: flex;
  align-items: center;
  font-size: 46px !important;
  margin-bottom: 40px;
      font-family:" Alegreya Sans";
}
h3{
  font-size: 24px;
}
.oplicy-h1 img{
  width: 55px !important;
}
h2{
  font-size: 35px !important;
}
</style>